// extracted by mini-css-extract-plugin
export default {"container":"domainsection_container__y2QtZ"};